<template>
  <section class="hero">
    <div class="container">
      <h1>
        O imóvel dos seus sonhos está aqui! <br />Descubra nossas ofertas
        exclusivas.
      </h1>
      <form class="hero-search">
        <h2>Confira nossas melhores oportunidades.</h2>
        <div class="options">
          <div class="box-search">
            <select
              class="select"
              v-model="stateSelected"
              v-on:change="onChange"
            >
              <option
                v-for="item in this.states"
                :value="item"
                :key="item.id"
                >{{ item.attributes.name }}</option
              >
            </select>
          </div>
          <div class="box-search">
            <select class="select" v-model="citySelected">
              <option
                v-for="item in this.cities"
                :value="item"
                :key="item.id"
                >{{ item.attributes.name }}</option
              >
            </select>
          </div>
          <router-link
            class="button-primary"
            :to="{
              name: 'PropertiesList',
              params: {
                states: this.states,
                cities: this.cities,
                state: stateSelected,
                city: citySelected
              }
            }"
          >
            Buscar
          </router-link>
        </div>
        <p>Mais de 2.000 imóveis vendidos em todo o Brasil</p>
      </form>
    </div>
  </section>
</template>

<script>
import { regionsService } from "@/services/regions.service";

export default {
  name: "Hero",
  data() {
    return {
      states: [],
      cities: [],
      stateSelected: {},
      citySelected: {},
      state: {},
      city: {}
    };
  },

  mounted() {
    this.state = { id: "", attributes: { name: "Estado" } };
    this.city = { id: "", attributes: { name: "Cidade" } };
    this.states = [this.state];
    this.cities = [this.city];
    this.stateSelected = this.states[0];
    this.citySelected = this.cities[0];

    this.getStates();
  },

  methods: {
    async getStates() {
      try {
        const response = await regionsService.retrieveStates();
        this.states = [].concat.apply(this.states, response.data.data);
      } catch {
        console.log("Ocorreu um erro inesperado.");
      }
    },

    async getCities(id) {
      try {
        const params = { stateId: id };
        const response = await regionsService.retrieveRegions(params);
        this.cities = [].concat.apply([this.city], response.data.data);
      } catch {
        console.log("Ocorreu um erro inesperado.");
      }
    },

    onChange: function() {
      this.cities = [this.city];
      const id = this.stateSelected.id;
      this.citySelected = this.cities[0];
      this.getCities(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/select";

.hero {
  background: url("~@/assets/banner-hero.png") top right no-repeat;
  background-size: calc(50%);
  min-height: 700px;
  display: flex;

  .container {
    display: flex;
    height: 100%;
    flex-direction: column;
    max-width: 1200px;
    position: relative;

    h1 {
      max-width: 580px;
      color: var(--blue-custom);
      line-height: 54px;
      font-size: var(--size-h1);
      padding: 127px 80px 78px 0px;
      font-weight: bold;
      font-family: var(--font-primary);
    }

    .hero-search {
      background: #ffffffbb;
      border-radius: 80px;
      width: 100%;
      padding: 20px 56px;
      height: 180px;
      max-width: 750px;
      display: block;
      align-items: center;
      justify-content: space-between;

      h2 {
        padding: 8px 0 20px 0;
        font-size: calc(var(--size-large) + 2px);
      }

      .options {
        display: flex;
        justify-content: space-between;
      }

      .box-search {
        margin-right: 16px;
        position: relative;
        width: 200px;

        &:nth-child(1) {
          border-right: 1px solid #efefef;
        }

        .select {
          position: absolute;
          top: 0px;
          max-width: 190px;
          width: 100%;
          height: 100%;
          font-size: calc(var(--size-large) + 2px);
          font-family: var(--font-primary);
          font-weight: 300;
          color: var(--grey-dark-custom);
        }
      }

      p {
        font-size: var(--size-large);
        line-height: 29px;
        font-family: var(--font-primary);
        font-weight: 300;
        margin-top: 20px;
        color: var(--blue-custom);
      }
    }
  }

  @media (max-width: 768px) {
    min-height: initial;
    background-position: top right;
    background-size: 100%;

    .container {
      height: 100%;
      display: block;
      flex-direction: row;
      align-items: center;

      h1 {
        padding: 140px 0 50px;
        margin: -40px 0 0;
        font-size: calc(var(--size-large) + 7px);
        max-width: 100%;
        line-height: 36px;
        color: var(--white);
        text-align: center;
        text-shadow: 5px 5px 10px #000;
      }

      .hero-search {
        margin: 0 auto;
        border-radius: 20px;
        flex-direction: column;
        padding: 16px;
        height: 340px;
        background: var(--white);
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);

        h2 {
          padding: 2px 0 20px 0;
          font-size: calc(var(--size-regular) + 2px);
        }

        .options {
          display: block;
          align-items: center;
          justify-content: space-between;
        }

        .box-search {
          border: none !important;
          width: 100%;
          height: 70px;
          padding: 0;
          margin: 0 0 8px;

          .select {
            max-width: 100%;
          }

          p {
            font-size: var(--size-regular);
            margin-top: 4px;
          }
        }

        .select {
          font-size: calc(var(--size-large) + 4px);
        }

        .button-primary {
          display: block;
          width: 100%;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
